<template>
  <div
    ref="scrollable"
    :class="b({ trackVisible, invisible })"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import SimpleBar from 'simplebar';
  import 'simplebar/dist/simplebar.min.css';

  type Data = {
    simpleBar: SimpleBar | null;
  };

  /**
   * Renders a scrollable container.
   *
   * https://grsmto.github.io/simplebar/
   */
  export default {
    name: 'e-scrollable',

    // components: {},
    // mixins: [],

    props: {
      /**
       * Determines if the track should be visible.
       */
      trackVisible: {
        type: Boolean,
        default: false,
      },

      /**
       * Use to set all scrollbars to be invisible.
       */
      invisible: {
        type: Boolean,
        default: false,
      },
    },

    // emits: [],

    data(): Data {
      return {
        simpleBar: null,
      };
    },

    // computed: {},
    // mergedConfig() {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      this.$nextTick(() => {
        // Fixes wrong track height calculations
        this.simpleBar = new SimpleBar(this.$el, {
          autoHide: false,
        });
      });
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use 'sass:math';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/functions';

  .e-scrollable {
    .simplebar-scrollbar::before {
      left: 0;
      right: 0;
      border-radius: 0;
    }
  }
</style>
